import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { pluck } from 'rxjs/operators';

@Injectable()
export class PassengersService {

  constructor(private http: HttpClient) { }

  getPassengers(options) {
    return this.http.get('operator/passenger/accounting', { params: new HttpParams({ fromObject: options }) });
  }

  getPassenger(obj) {
    return this.http.get('operator/passenger/accounting/bonus/history', { params: new HttpParams({ fromObject: obj }) });
  }

  getPassengerHistory(type, obj) {
    return this.http.get(`operator/${type}`, { params: new HttpParams({ fromObject: obj }) }).pipe(pluck('data'));
  }

  getPassengersBlockReasons() {
    return this.http.get('operator/blocking/reasons?type=passenger_block');
  }

  blockPassengers(body) {
    return this.http.post('operator/passenger/block', body);
  }

  unblockPassengers(body) {
    return this.http.post('operator/passenger/unblock', body);
  }

}



// WEBPACK FOOTER //
// ./src/app/passengers/passengers.service.ts